import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { MIME_TYPE_TO_EXTENSION } from 'lib/constants'

import Icon from 'components/Icon'

import './file-image.pcss'

const FileImage = ({ imageUrl, mediaType, fileName, size = 'auto', contain = false }) => {
    const renderFileInfo = () => {
        switch (size) {
        case 's':
            return MIME_TYPE_TO_EXTENSION[mediaType]
        default:
            return (
                <div>
                    <Icon
                        fa
                        name={['fal', 'paperclip']}
                        color="gray"
                        size="xxxxl"
                        forceSize
                    />
                    <span>{fileName}</span>
                </div>
            )
        }
    }

    return (
        <div
            className={classNames('file-image', `file-image--size-${size}`, {
                'file-image--nothumb': !imageUrl,
                'file-image--contain': contain,
            })}
        >
            {imageUrl ? (
                <img src={imageUrl} alt={fileName} />
            ) : (
                <span className="file-image__file-info">
                    {renderFileInfo()}
                </span>
            )}
        </div>
    )
}

FileImage.propTypes = {
    imageUrl: PropTypes.string,
    fileName: PropTypes.string.isRequired,
    mediaType: PropTypes.string.isRequired,
    size: PropTypes.string,
    contain: PropTypes.bool,
}

export default FileImage
